const styles = theme => ({
  dialogsContainerDialog: { zIndex: 1301 },
  dialogPaper: {
    width: "100%",
    maxWidth: 800
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"]
  },
  header: {
    backgroundColor: theme.palette.primary.main,
    overflow: "unset"
  },
  headerTitle: {
    color: theme.palette.warning.light,
    textTransform: "none",
    "@supports (padding-top: constant(safe-area-inset-top))": {
      "--safe-area-inset-top": "constant(safe-area-inset-top)",
      paddingTop: "var(--safe-area-inset-top)"
    },
    "@supports (padding-top: env(safe-area-inset-top))": {
      "--safe-area-inset-top": "env(safe-area-inset-top)",
      paddingTop: "var(--safe-area-inset-top)"
    }
  },
  headerSubtitle: {
    color: theme.palette.warning.light
  },

  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    margin: 0,
    "@supports (padding-bottom: constant(safe-area-inset-bottom))": {
      "--safe-area-inset-bottom": "constant(safe-area-inset-bottom)",
      paddingBottom: "calc(16px + var(--safe-area-inset-bottom))"
    },
    "@supports (padding-bottom: env(safe-area-inset-bottom))": {
      "--safe-area-inset-bottom": "env(safe-area-inset-bottom)",
      paddingBottom: "calc(16px + var(--safe-area-inset-bottom))"
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3)
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/DialogsContainer/styles.js